import useCharger from 'hooks/useCharger';
import type { GoeDeviceType } from 'utils/communication/websocketTypes';

import type { DeviceSerial } from 'redux-store/slices/ui/types';

const useIsDigitalInputSupported = (
  serial: DeviceSerial | undefined,
  typ: GoeDeviceType | undefined,
): boolean => {
  const protectDigitalInput = useCharger(serial, state => state?.pdi);
  const isgo = useCharger(serial, state => state?.isgo);
  const digitalInputEnabled = useCharger(serial, status => status?.die);

  return (
    typ !== undefined &&
    protectDigitalInput !== undefined &&
    !isgo &&
    digitalInputEnabled !== undefined
  );
};

export default useIsDigitalInputSupported;
